var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOrgSecurityIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#orgSecurityIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#31135E",
  d: "M6.563 3.563A.561.561 0 0 0 6 3a.561.561 0 0 0-.563.563v2.624c0 .312.251.563.563.563.312 0 .563-.25.563-.563V3.563ZM6 9a.75.75 0 1 0 0-1.5A.75.75 0 0 0 6 9Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1C21B",
  d: "M5.205.431a1.127 1.127 0 0 1 1.592 0L7.863 1.5h1.512c.621 0 1.125.504 1.125 1.125v1.512l1.069 1.068c.438.439.438 1.151 0 1.592L10.5 7.863v1.512c0 .621-.504 1.125-1.125 1.125H7.863l-1.068 1.069a1.128 1.128 0 0 1-1.592 0L4.137 10.5H2.625A1.125 1.125 0 0 1 1.5 9.375V7.863L.431 6.795a1.127 1.127 0 0 1 0-1.592L1.5 4.137V2.625c0-.621.504-1.125 1.125-1.125h1.512L5.205.431ZM6 3a.561.561 0 0 0-.563.563v2.624c0 .312.251.563.563.563.312 0 .563-.25.563-.563V3.563A.561.561 0 0 0 6 3Zm.75 5.25a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "orgSecurityIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z"
})))));
export default SvgOrgSecurityIcon;